export const ID_TO_FILTER = {
  siteId: 'site',
  region: 'region',
  clientId: 'client',
  specieId: 'specie',
}

export const FILTER_TO_ID = {
  site: 'siteId',
  region: 'region',
  client: 'clientId',
  specie: 'specieId',
}

export const FILTER_TO_ID_FRESHWATER = {
  clientName: 'clientId',
}
